import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFObject from "PDFLib/core/objects/PDFObject";

export class PrecompiledStringJSONItem extends JSONItemBase{
    GetType() {
        return 'PS'
    }

    public Text:string;

    constructor(item:PDFObject) {
        super();
        this.Text =item.toString();


    }
}